<template>
  <v-dialog v-model="state.open" scrollable persistent xs4 max-width="500">
    <v-card v-if="step === STEP_1">
      <v-card-title>
        <span class="headline">Glemt passord?</span>
      </v-card-title>

      <v-card-text>
        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="step1" key="step1" />

        <v-container>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                prepend-icon="email"
                label="Din e-post"
                type="email"
                v-model="email"
                @keyup.enter="submitCredentials"
                :disabled="isSubmitting"
                ref="focusField"
                required
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          @click.native="closeDialog"
          :disabled="isSubmitting"
          flat
        >Lukk</v-btn>
        <v-btn
          color="primary"
          :disabled="isSubmitting"
          @click.native="submitCredentials"
          dark
        >Neste steg</v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="step === STEP_2">
      <v-card-title>
        <span class="headline">Skriv inn kode</span>
      </v-card-title>

      <v-card-text>
        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="step2" key="step2" />

        <v-container>
          <p>
            En e-post har blitt sendt til <strong>{{ email }}</strong> med en kode som du må skrive inn i feltet under.
          </p>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                label="Skriv inn kode"
                v-model="code"
                @keyup.enter="submitCode"
                :disabled="isSubmitting"
                ref="focusField"
                required
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Sett nytt passord"
                type="password"
                v-model="password"
                @keyup.enter="submitCode"
                :disabled="isSubmitting"
                required
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                label="Skriv passordet igjen"
                type="password"
                v-model="password2"
                @keyup.enter="submitCode"
                :disabled="isSubmitting"
                required
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="grey darken-1"
          @click.native="closeDialog"
          :disabled="isSubmitting"
          flat
        >Lukk</v-btn>
        <v-btn
          color="primary"
          :disabled="isSubmitting"
          @click.native="submitCode"
          dark
        >Endre passord</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

const STEP_1 = 1
const STEP_2 = 2

export default {
  props: ['state'],
  mounted () {
    this.$watch('state.open', (isShown) => {
      if (isShown) {
        this.consumeNotifications('step1')
        this.consumeNotifications('step2')
        this.step = STEP_1
        this.$refs.focusField.focus()
      }
    })
  },
  data () {
    return {
      STEP_1: STEP_1,
      STEP_2: STEP_2,
      step: STEP_1,
      email: '',
      code: '',
      password: '',
      password2: '',
      isSubmitting: false
    }
  },
  methods: {
    closeDialog () {
      this.email = ''
      this.code = ''
      this.password = ''
      this.password2 = ''
      this.$emit('close')
    },
    async submitCredentials () {
      if (this.email.length === 0) {
        this.addNotification(true, {
          group: 'step1',
          type: 'error',
          text: 'Vennligst fyll inn alle påkrevde felter'
        })
        return
      }

      const response = await this.runService(this, 'step1', AuthenticationService.forgotPasswordCredentials, {
        email: this.email
      })
      if (response) {
        if (response.data.notFound) {
          this.addNotification(true, {
            group: 'step1',
            type: 'error',
            text: 'Vi kunne ikke finne din e-post i vårt system. Vennligst ta kontakt på ' + this.config.EMAIL + ' slik at vi får oppdatert din informasjonen.'
          })
        } else {
          this.step = STEP_2
        }
      }
    },
    async submitCode () {
      if (this.code.length * this.password.length * this.password2.length === 0) {
        this.addNotification(true, {
          group: 'step2',
          type: 'error',
          text: 'Vennligst fyll inn alle påkrevde felter'
        })
        return
      }

      if (this.password !== this.password2) {
        this.addNotification(true, {
          group: 'step2',
          type: 'error',
          text: 'Passordene du skrev inn er forskjellige'
        })
        return
      }

      const response = await this.runService(this, 'step2', AuthenticationService.forgotPasswordCode, {
        code: this.code,
        password: this.password
      })

      if (response) {
        if (response.data.notFound) {
          this.addNotification(true, {
            group: 'step2',
            type: 'error',
            text: 'Koden du skrev inn var feil, eller har utløpt. Vennligst prøv igjen.'
          })
        } else {
          this.$emit('resetPassword', this.email)
          this.closeDialog()
        }
      }
    }
  }
}
</script>

<style scoped>
.alert {
  display: block
}
</style>
